export {
  XpmIntegrationCta,
  type XpmIntegrationCtaProps,
} from './XpmIntegrationCta';
